import { message, Row, Spin } from 'antd';
import { get_response } from 'helper/request';
import { sagaMiddleware, store } from 'helper/store';
import { Component } from 'react';
import { connect } from "react-redux";
import "../../asset/style/scanner/scanner.css";
import {getDeviceProperties} from "../../redux_actions/device.action";
import {setDeviceBusy, setDeviceIdle, watchPollStatus} from '../../redux_actions/device_status.action';
import {initPreviewForScan} from "../../redux_actions/preview_status.action";
import {
    antdSpinLoaderIcon,
    antdSpinLoaderSmallIcon,
    cassetteType,
    progressStage,
    scanWorkflowLoadingMessages
} from "../../utils/const";
import {scanPageSelector} from "../../utils/scanner_utils";
import {isTrue, notNull, isNull} from "../../utils/utils";
import ReloadConfigPromptWrapper from './reload_config_prompt_wrapper';
import ScannerTimeline from './scanner_timeline';
import ScanProgress from './scanWorkflow/scan_progress';
import SetScanParamsView from './scanWorkflow/set_scan_params_view_new';

export class ScanWorkflowNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentProcessStage: progressStage.LOAD_SLIDES,
            ready: false,
            firstTime: true,
            cassetteType: cassetteType.SIX_1_BY_3_SLIDES, // default
            detectingCassette: false,
            askUserCassetteType: false, // if true, we ask user the cassette type manually
            isScanProcessing: false,
        }
        this.cassetteSize = -1;
        this.specimType = "";
    }

    componentDidMount = () => {
        this.poller = sagaMiddleware.run(watchPollStatus, store.dispatch, this.props.match.params.id);
        this.getScannerProperties();
    }

    componentWillUnmount = () => {
        this.poller.cancel();
    }

    componentDidUpdate(prevProps) {
        this.redirectIfNecessary();
        if (this.state.firstTime) {
            if (this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.insertedCassetteType && 
                (this.state.cassetteType!==this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.insertedCassetteType)){
                    this.setState({
                    cassetteType: this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.insertedCassetteType
                })
            }
        }

        let isScanning = this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.scanning;
        let isPrevScanning = prevProps.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.scanning;
        if(isScanning !== isPrevScanning && isScanning) {
            this.setState({isScanProcessing: false})
            this.props.history.push("/scannerflow/" + this.props.match.params.id + "/" + scanPageSelector(this.props.match.params.id) + "/" + progressStage.SCANNING + "/");
        }

    }

    redirectIfNecessary = () => {
        if (notNull(this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.scanning)) {
            const currentScanType = scanPageSelector(this.props.match.params.id);
            if (isTrue(this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.scanning)) {
                // Blood scans wont go to SCANNING i assume, maybe thats why splitting code
                if(currentScanType === "blood-scan"){
                    if (!window.location.href.includes("/blood-scan"))
                    this.props.history.push("/scannerflow/" + this.props.match.params.id + `/${currentScanType}/` + this.props.match.params.stage + "/");
                } else {
                    if (this.props.match.params.stage !== progressStage.SCANNING) {
                        this.props.history.push("/scannerflow/" + this.props.match.params.id + `/${currentScanType}/` + progressStage.SCANNING + "/");
                    }
                }
            } else {
                if (this.state.currentProcessStage === progressStage.LOAD_SLIDES && !isTrue(this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.supports2by3Cassette)) {
                    this.setState({currentProcessStage: progressStage.SET_PARAMETERS})
                    this.props.history.push("/scannerflow/" + this.props.match.params.id + `/${currentScanType}/` + progressStage.SET_PARAMETERS + "/");
                }
            }
            if (this.state.firstTime) {
                this.setState({firstTime: false});
            }
        }
    }


    navigateToScannerDashboard = () => {
        this.props.history.push("/scanners/" + this.props.match.params.id);
    }

    setSpecimenType = (res) => null;

    getScannerProperties = () => {
        this.props.dispatch(setDeviceBusy(this.props.match.params.id, "Setting Up"));

        this.props.dispatch(getDeviceProperties(this.props.match.params.id)).then(() => {
            const data = this.props.deviceProperties
            for (let i = 0; i < data.cassetteSize; i++) {
                this.initSlot(i, data.defaultConfig);
            }
            this.setState(Object.assign({}, this.state, {
                defaultConfig: data.defaultConfig,
                scannerProperties: data,
            }));
            this.cassetteSize = data.cassetteSize;
            this.props.dispatch(setDeviceIdle(this.props.match.params.id));
        })
    }

    initSlot = (slot, defaultConfig) => {
        this.props.dispatch(initPreviewForScan(slot, defaultConfig)).then(() => {this.setState({ready:true})});
    }

    setDetectingCassette = (detecting) => {
        this.setState({detectingCassette: detecting});
    }

    // for Maximus scanner, user selected cassette type
    setCassetteType = (cassetteType) => {
        // 1. set cassette type in backend
        let url = `/server/devices/` + this.props.match.params.id + "/set_cassette_type?cassette_type=" + cassetteType;

        get_response(url)
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                // 2. update UI
                console.debug("user selected cassetteType=", cassetteType);
                this.setState({
                    cassetteType: cassetteType
                });

                // UPDATE after detection
                this.setState({
                    currentProcessStage: progressStage.SET_PARAMETERS,
                    detectingCassette: false,
                    askUserCassetteType: false
                });
                this.props.history.push("/scannerflow/" + this.props.match.params.id + "/scan/" + progressStage.SET_PARAMETERS + "/");
            }
        })
        .catch(err => {
            console.log(err);
            message.error("Failed to set cassette type, please contact Morphle Admin");
        });
    }

    handleProgressChange = (stage) => {
        
        // detect cassette type at this stage
        if (stage == progressStage.SET_PARAMETERS && isTrue(this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.supports2by3Cassette)) {
            this.setState({detectingCassette: true});
            let url = `/server/devices/` + this.props.match.params.id + "/detect_cassette_type/";
            get_response(url)
                .then(response => {
                    if (response.status === 200 || response.status === 301 || response.status === 302) {

                        if (response.data.detectionSuccess) {
                            console.debug("cassette detection response", response.data);
                            this.setState({
                                cassetteType: response.data.cassetteType
                            });
    
                            // UPDATE after detection
                            this.setState({
                                currentProcessStage: progressStage.stage,
                                detectingCassette: false
                            });
                            console.debug("handleProgressChange", stage);
                            this.props.history.push("/scannerflow/" + this.props.match.params.id + "/scan/" + stage + "/");
                        } else {
                            console.warn("failed to detect cassette, asking user");
                            this.setState({
                                detectingCassette: false,
                                askUserCassetteType: true
                            });
                        }
                    } else {
                        // detection failed, ask user
                        console.error("response is", response);

                        console.warn("failed to detect cassette, asking user");
                        this.setState({
                            detectingCassette: false,
                            askUserCassetteType: true
                        });
                    }
                })
                .catch(err => {
                    console.error("error detecting cassette:", err);

                    console.warn("failed to detect cassette, asking user");
                    this.setState({
                        detectingCassette: false,
                        askUserCassetteType: true
                    });
                })
        } else {
            this.setState({
                currentProcessStage: progressStage.stage,
                isScanProcessing: true,
            })
            let isScanningStarted = this.props.deviceStatus[this.props.match.params.id]?.scanner_health?.scanner_response?.scanning;
            if(isScanningStarted) {
                this.props.history.push("/scannerflow/" + this.props.match.params.id + "/" + scanPageSelector(this.props.match.params.id) + "/" + stage + "/");
            }
        }
    }

    setScanParams = () => <SetScanParamsView
        setDetectingCassette={this.setDetectingCassette}
        detectingCassette={this.state.detectingCassette}
        askUserCassetteType={this.state.askUserCassetteType}
        setCassetteType={this.setCassetteType}
        handleProgressChange={this.handleProgressChange}
        device_id={this.props.match.params.id}
        currentProcessIndex={this.props.match.params.stage}
        previews={this.props.previews}
        scannerProperties={this.state.scannerProperties}
        progressStage={this.props.match.params.stage}
        navigateToScannerDashboard={this.navigateToScannerDashboard}
        defaultConfig={this.state.defaultConfig}
        cassetteType={this.state.cassetteType}
    />

    render() {
        let isCancelling = (((this.props.deviceStatus[this.props.match.params.id] || {}).scanner_health || {}).scanner_response || {})?.cancellingScan;
        let busyOrder = ((((this.props.deviceStatus[this.props.match.params.id] || {}).scanner_health || {}).scanner_response || {}).busyOrder || [])
        let busyDict = ((((this.props.deviceStatus[this.props.match.params.id] || {}).scanner_health || {}).scanner_response || {}).busyDict || {})
        let busyMessage = busyDict[busyOrder[0]]?.includes(scanWorkflowLoadingMessages.SCAN_CRASHED)

        return (
            <ReloadConfigPromptWrapper deviceId={this.props.match.params.id}>
                <Spin indicator={antdSpinLoaderIcon} style={{marginTop: 75}} spinning={this.state.isScanProcessing || this.props.isCassetteEjecting || isCancelling || (notNull(busyMessage) && busyMessage)}>
                    {!(((this.props.deviceStatus[this.props.match.params.id] || {}).scanner_health || {}).scanner_response || {}).recommendServerRestart ?
                    this.cassetteSize !== -1 ?
                        <Row className="scanflow-container">
                            <ScannerTimeline currentProcessIndex={this.props.match.params.stage}
                                             handleProgressChange={this.handleProgressChange}
                                             device_id={this.props.match.params.id} type={this.specimType}/>
                            {this.props.match.params.stage === progressStage.LOAD_SLIDES ?
                                this.setScanParams()
                                :
                                this.props.match.params.stage === progressStage.SET_PARAMETERS ?
                                    this.setScanParams() :
                                    this.props.match.params.stage === progressStage.SCANNING ?
                                        <ScanProgress
                                            handleProgressChange={this.handleProgressChange}
                                            device_id={this.props.match.params.id}
                                            scannerProperties={this.state.scannerProperties}
                                            cassetteType={this.state.cassetteType}
                                        />
                                        : null
                            }
                        </Row> :
                        <div style={{width: '100%', height: '800px'}} className="rounded-container">
                            <Spin indicator={antdSpinLoaderSmallIcon} style={{color: '#000'}}
                                  spinning={this.cassetteSize === 0} tip="Taking Preview...">
                                <div style={{width: '100%', height: '800px'}}></div>
                            </Spin>
                        </div>
                    :
                    this.navigateToScannerDashboard()
                    }
                </Spin>
                </ReloadConfigPromptWrapper>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isCassetteEjecting: state.scanWorkflowReducer.isCassetteEjecting,
        previews: state.previewStatusReducer,
        deviceProperties: state.deviceAlert.deviceProperties,
        deviceStatus: state.deviceStatusReducer,
    };
};

export default connect(mapStateToProps)(ScanWorkflowNew);
